import React from 'react';

const SkeletonCard = () => (
    <div className="bg-white/5 rounded-[2.5rem] p-4 border border-white/10 animate-pulse">
        <div className="h-64 bg-white/10 rounded-[2rem] mb-4"></div>
        <div className="h-6 bg-white/10 rounded-full w-3/4 mb-2"></div>
        <div className="h-8 bg-white/10 rounded-full w-1/2"></div>
    </div>
);

export default SkeletonCard;